export function pickRandomElement<T>(array: T[]): T {
  if (!array || !Array.isArray(array)) {
    throw new Error('cant pick element from empty or non array')
  }
  return array[Math.floor(Math.random() * array.length)]
}
